<ngx-skeleton-loader
  [hidden]="loaded"
  [theme]="{ width: '100%', height: '100%' }"
></ngx-skeleton-loader>
<div #map class="map" [class.loaded]="loaded"></div>
<div class="error" *ngIf="error">
  <p>{{ 'search.map.webgl.disabled' | translate }}</p>
</div>
